import { useCallback, useEffect, useState } from 'react';

import { Box, IconButton, Paragraph, VisuallyHidden } from '@zillow/constellation-10';
import { IconChevronDownFilled, IconChevronUpFilled } from '@zillow/constellation-icons';

interface QuestionAnswerProps {
  question: string;
  answer: string;
  i: number;
  isMobile: boolean;
}

const QuestionAnswer: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<QuestionAnswerProps>>> = (
  props,
) => {
  const { question, answer, i, isMobile } = props;
  const [expanded, setExpanded] = useState(!isMobile);
  useEffect(() => {
    setExpanded(!isMobile);
  }, [isMobile]);
  const expand = useCallback(() => setExpanded(!expanded), [expanded]);
  return isMobile ? (
    <>
      <Box css={{ display: 'flex', alignItems: 'baseline' }}>
        <Paragraph textStyle="body-bold" css={{ marginBottom: '400', width: '80%' }}>
          {i + 1}. {question}
        </Paragraph>
        <IconButton
          icon={expanded ? <IconChevronUpFilled /> : <IconChevronDownFilled />}
          emphasis="bare"
          title={expanded ? 'Collapse' : 'Expand'}
          size="sm"
          onClick={expand}
          css={{ width: '20%', borderWidth: 0 }}
        />
      </Box>
      {expanded ? (
        <Paragraph color="text.subtle" css={{ marginBottom: '800' }}>
          <div dangerouslySetInnerHTML={{ __html: answer }} />
        </Paragraph>
      ) : (
        <VisuallyHidden>
          <div dangerouslySetInnerHTML={{ __html: answer }} />
        </VisuallyHidden>
      )}
    </>
  ) : (
    <>
      <Paragraph textStyle="body-bold" css={{ marginBottom: '400' }}>
        {i + 1}. {question}
      </Paragraph>
      <Paragraph color="text.subtle" css={{ marginBottom: '800' }}>
        <div dangerouslySetInnerHTML={{ __html: answer }} />
      </Paragraph>
    </>
  );
};

export default QuestionAnswer;
